document.addEventListener("DOMContentLoaded", () => {
  const setupFlagWatcher = ({ selector, flag, onUpdate }) => {
    const el = document.querySelector(selector);
    if (!el) return;

    const applyFeatureFlags = () => {
      const value = window._growthbook?.getFeatureValue(flag, false);
      onUpdate(el, value);
    };

    // Cola para growthbook
    window.growthbook_queue = window.growthbook_queue || [];
    window.growthbook_queue.push(() => {
      applyFeatureFlags();
      document.addEventListener("growthbookdata", applyFeatureFlags);
    });
  };

  // Sticky cart
  setupFlagWatcher({
    selector: ".sticky-cart-container",
    flag: "sticky-add-to-cart",
    onUpdate: (el, active) => {
      el.style.display = active ? "block" : "none";
    },
  });

  // Urgency callout
  setupFlagWatcher({
    selector: ".urgency-callout-container",
    flag: "urgency-callout-obo",
    onUpdate: (el, active) => {
      el.classList.toggle("show", active);
    },
  });
});
